import * as React from 'react'

import { spacing, styled } from '@thg-commerce/gravity-theme'
import { Skeleton, Separator } from '@thg-commerce/gravity-elements'

import {
  DisclaimerText,
  IndividualReviews,
  MainWrapper,
  ReviewOverview,
  ReviewsGrid,
  ReviewTitle,
  TopReviewsTitle,
} from '../styles'

export const ReviewContentWrapper = styled.div`
  max-width: 530px;
`

const StyledReviewSection = styled.div`
  border-bottom: solid 1px ${(props) => props.theme.colors.palette.greys.light};
  padding: ${spacing(4)} 0;
`

const ProductContentButtonWrapper = styled.div`
  display: flex;
  margin-top: ${spacing(2)};
  gap: 8px;
`

export const StyledSkeleton = styled(Skeleton)<{
  width?: number
  height?: number
  marginTop?: number
  marginBottom?: number
}>`
  height: ${(props) => props.height ?? 16}px;
  width: ${(props) => props.width ?? 100}%;
  ${(props) => props.marginTop && `margin-top: ${spacing(props.marginTop)};`}
  ${(props) =>
    props.marginBottom && `margin-bottom: ${spacing(props.marginBottom)};`}
`

export type TopProductReviewSkeletonProps = {
  customerReviewsTitle: string
  topCustomerReviews: string
  customerReviewsDisclaimer: string
}

export const ProductRatingSkeleton = () => {
  return (
    <React.Fragment>
      <StyledSkeleton height={24} width={50} marginTop={3} marginBottom={2.5} />
      <StyledSkeleton width={20} marginBottom={3.5} />
      <StyledSkeleton height={20} marginBottom={1} />
      <StyledSkeleton height={20} marginBottom={1} />
      <StyledSkeleton height={20} marginBottom={1} />
      <StyledSkeleton height={20} marginBottom={1} />
      <StyledSkeleton height={20} marginBottom={4} />
      <StyledSkeleton height={20} width={35} marginBottom={5} />
    </React.Fragment>
  )
}

const ProductReviewContentSingleSkeleton = () => {
  return (
    <React.Fragment>
      <StyledSkeleton height={24} width={40} marginTop={3} marginBottom={2.5} />
      <StyledSkeleton width={15} marginBottom={3} />
      <ReviewContentWrapper>
        <StyledSkeleton height={15} width={100} marginBottom={1} />
        <StyledSkeleton height={15} width={98} marginBottom={1} />
        <StyledSkeleton height={15} width={95} marginBottom={1} />
        <StyledSkeleton height={15} width={100} marginBottom={1} />
      </ReviewContentWrapper>

      <StyledSkeleton height={15} width={50} marginTop={3} />
      <StyledSkeleton height={15} width={20} marginTop={3} />

      <ProductContentButtonWrapper>
        <StyledSkeleton height={40} width={22} />
        <StyledSkeleton height={40} width={22} />
      </ProductContentButtonWrapper>

      <StyledSkeleton height={15} width={25} marginTop={4} />
    </React.Fragment>
  )
}

export const createProductReviewContentSkeletons = (
  totalReviewContent: number,
) => {
  return [...Array(totalReviewContent)].map((_, index) => (
    <StyledReviewSection key={index}>
      <ProductReviewContentSingleSkeleton />
    </StyledReviewSection>
  ))
}

export const TopProductReviewsSkeleton = (
  props: TopProductReviewSkeletonProps,
) => {
  return (
    <MainWrapper>
      <ReviewTitle>{props.customerReviewsTitle}</ReviewTitle>
      <ReviewsGrid>
        <ReviewOverview colSpan={[12, 12, 4, 4]} colStart={1}>
          <ProductRatingSkeleton />
        </ReviewOverview>
        <IndividualReviews colSpan={[12, 12, 7, 7]} colStart={[1, 1, 6, 6]}>
          <div>
            <TopReviewsTitle>{props.topCustomerReviews}</TopReviewsTitle>
            <DisclaimerText>{props.customerReviewsDisclaimer}</DisclaimerText>
          </div>
          <Separator />
          {createProductReviewContentSkeletons(5)}
        </IndividualReviews>
      </ReviewsGrid>
    </MainWrapper>
  )
}
